import React, { createRef } from 'react'
import Button from '@material-ui/core/Button'
import CloseIcon from '@material-ui/icons/Close'
import { SnackbarProvider } from 'notistack'
import ReactDOM from 'react-dom'
import App from './App'
import { GlobalStyles } from 'tce-componentes-ui-react'
import GlobalStyle from './styles'
import './assets/index.css'

import { Provider } from 'react-redux'
import { store } from './redux/store'
import { AuthProvider } from 'react-oidc-context'

const notistackRef = createRef()
const onClickDismiss = key => () => { 
    notistackRef.current.closeSnackbar(key)
}

const oidcConfig = {
  authority: process.env.REACT_APP_OIDC_AUTHORITY,
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_URL_TCECOMUNICA
}

if (localStorage.getItem(`@${process.env.REACT_APP_NOME_SISTEMA}-data`) === null) {
  localStorage.setItem(`@${process.env.REACT_APP_NOME_SISTEMA}-data`, JSON.stringify({ id: '', nome: '', email: '', setor: '', usuario: ''}))
}

ReactDOM.render(
  <>    
  <AuthProvider {...oidcConfig}>
  <SnackbarProvider 
    ref={notistackRef}
    action={(key) => (
      <Button className="btnCloseSnackBar" onClick={onClickDismiss(key)} component="span">
          <CloseIcon/>
      </Button>
    )}
    autoHideDuration={4000}
    maxSnack={10}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
  >
    <Provider store={store}>
      <GlobalStyles />
      <GlobalStyle />
        <App />
    </Provider>
  </SnackbarProvider>
  </AuthProvider>
  </>,
  document.getElementById('root')
)